// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'babel-polyfill'

// Plugins
import router from './plugins/router.js'
import {store} from './plugins/store.js'
import VueYoutube from './plugins/youtube.js'
import VeeValidate from './plugins/validate.js'
import VeeResource from './plugins/resource.js'
import Notifications from './plugins/notification.js'
import VueAnalytics from 'vue-analytics'
import VueBar from './plugins/vuebar.js'
import Data from './plugins/data.js'
import VModal from 'vue-js-modal'
import vSelect from 'vue-select'

import App from './App'

// include animate css
require('vue2-animate/dist/vue2-animate.min.css')
import 'vue-select/dist/vue-select.css';
import './assets/style/css/application.css'
import './assets/style/css/responsive.css'

Vue.config.productionTip = false
Vue.config.silent = true;

Vue.use(VModal);

Vue.component('v-select', vSelect)

// Vue.use(VueAnalytics,{
//     id: 'UA-113892189-1',
//     router
// }); // @LIVE DEV

// Redirect if no access token aka inital form not filled
router.beforeEach((to, from, next) => {
    if (to.path != '/') { // they have no access token
        // and check token
        if (hasAccessToken()) {
            next()
        } else {
            next('LandingPage')
        }
    } else {
        next()
    }
});

function hasAccessToken() {
    console.log('main check');
    //whaddup storage, we got a token?
    if(!store.getters.hasAccessToken){
        // nup, bye!
        Vue.toasted.show('Please fill in the form to proceed.', {
            duration: 6000,
            position: 'top-center',
            type: "info",
            action: {
                text: 'CLOSE',
                onClick : (e, toastObject) => {
                    toastObject.goAway(0);
                }
            }
        });
        return false;
    } 
    // else if(!store.getters.accessTokenValid){
    //     // access token has expired
    //     Vue.toasted.show('Sorry! Your two hour session has expired.', {
    //         duration: 6000,
    //         position: 'top-center',
    //         type: "error",
    //         action: {
    //             text: 'CLOSE',
    //             onClick : (e, toastObject) => {
    //                 toastObject.goAway(0);
    //             }
    //         }
    //     });
    //     // delete localstorage

    //     return false;
    // }
    // proceed to give them what they need
    return true;
}

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store: store,
    components: {App},
    template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js